import React from 'react'
import PageHeader from '../components/PageHeader'
import GallerySection from '../components/GallerySection'
import PriceBanner from '../components/PriceBanner'
import ContactForm from '../components/ContactForm'
import { COMPANY_INFO } from '../lib/constants'

export default function ElArbejde() {
  return (
    <div className="space-y-16">
      <PageHeader
        badge="Private & Erhverv"
        title="Almindeligt El-arbejde"
        subtitle="25 års erfaring med almindelige el-opgaver i private boliger, sommerhuse, renovering og nybyggeri."
        breadcrumb="El-arbejde"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Main Content & Scrape Fidelity Block */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 space-y-8">
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <h2 className="text-2xl font-bold text-slate-900 tracking-tight">
                Erfaren elektriker til dine opgaver
              </h2>

              {/* Exact verbatim scrape text */}
              <div className="prose max-w-none text-slate-700 font-normal leading-relaxed space-y-4">
                <p className="text-base sm:text-lg font-normal text-slate-900">
                  jakobelektriker er en enkeltmands forretning.
                </p>
                <p className="font-normal">
                  Jeg udføre alle former for el-arbejde i private hjem. Jeg køre uafhængigt af en el- installatør. De el-opgaver der kræver en el-installatør løses også. Sådanne opgaver tilbydes udført i samarbejde med en El-installatør.
                </p>
                <p className="font-normal">
                  Samarbejde med både El-installatør virksomheder og andre Håndværksmestre er en stor del af min forretning. Mine 25 års erfaring som elektriker, både som service elektriker i mindre og større private opgaver og især som ny byg og renoverings elektriker for både privat og erhverv, gør jeg har prøvet det meste. Fra opgaver indenfor total renovering af sommerhuset til at planlægge, lede og fordele arbejdet i store byggesager der har taget op mod 3 år at gennemføre.
                </p>
              </div>

              {/* Clarification Box: Autorisationskrævende arbejde */}
              <div className="bg-slate-50 border border-slate-200 rounded-2xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#18191D] text-[#E36C0A] flex items-center justify-center shrink-0 mt-0.5">
                  <i className="fa-solid fa-shield-halved text-base" aria-hidden="true" />
                </div>
                <div className="space-y-1 text-xs sm:text-sm text-slate-700">
                  <span className="font-bold text-slate-900 block text-base">
                    Klare linjer: Samarbejde om autorisation
                  </span>
                  <p>
                    Jakob udfører almindeligt el-arbejde. Opgaver, der ved lov kræver autorisation, udføres altid i et tæt og etableret samarbejde med autoriserede el-installatører. Det giver dig tryghed for, at alt arbejde er lovligt og fuldt dokumenteret.
                  </p>
                </div>
              </div>
            </div>

            {/* Eksempler på el-opgaver */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <h3 className="text-xl font-bold text-slate-900">
                Typiske el-opgaver Jakob løser
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-slate-700">
                <div className="flex items-start gap-3 p-4 rounded-xl bg-slate-50 border border-slate-200/80">
                  <i className="fa-solid fa-bolt text-[#E36C0A] mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-slate-900 block">Renovering og nybyg</strong>
                    <span>Komplet el-arbejde i parcelhuse, lejligheder og sommerhuse.</span>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-4 rounded-xl bg-slate-50 border border-slate-200/80">
                  <i className="fa-solid fa-lightbulb text-[#E36C0A] mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-slate-900 block">Belysning og spots</strong>
                    <span>Opsætning og montering af indendørs og udendørs belysning.</span>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-4 rounded-xl bg-slate-50 border border-slate-200/80">
                  <i className="fa-solid fa-sliders text-[#E36C0A] mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-slate-900 block">Eltavler og sikringer</strong>
                    <span>Udskiftning og modernisering i samarbejde med el-installatør.</span>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-4 rounded-xl bg-slate-50 border border-slate-200/80">
                  <i className="fa-solid fa-network-wired text-[#E36C0A] mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-slate-900 block">Kabler og føringsveje</strong>
                    <span>Trækning af nye kabler til køkken, stue, værksted eller udbygning.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar with Direct Contact & Pricing */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-6 sm:p-8 shadow-xl border border-[#2D346E]/60 space-y-6">
              <div>
                <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#B5BBE8] mb-2 bg-[#252A6E]/50 border border-[#3C449E]/40 px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <span>Direkte kontakt</span>
                </span>
                <h3 className="text-2xl font-extrabold tracking-tight text-white mt-1">
                  Tal direkte med Jakob
                </h3>
                <p className="text-[#9FA6D9] text-xs sm:text-sm mt-2 leading-relaxed">
                  Ingen receptionister eller mellemled. Du taler direkte med den faglærte elektriker, der udfører arbejdet.
                </p>
              </div>

              <div className="pt-2">
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="flex items-center justify-center gap-2.5 w-full rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3.5 shadow-md transition-colors text-xs uppercase tracking-wider whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                  <span>Ring: {COMPANY_INFO.phone}</span>
                </a>
              </div>

              <div className="pt-4 border-t border-[#2D346E]/60 space-y-2 text-xs text-[#9FA6D9]">
                <div className="flex items-center justify-between">
                  <span>Fast timepris:</span>
                  <strong className="text-white font-bold">485 kr. ex. moms</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Servicevogn:</span>
                  <strong className="text-emerald-400 font-bold">Inkluderet</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Forsikring:</span>
                  <strong className="text-white font-bold">Fuldt forsikret</strong>
                </div>
              </div>
            </div>

            {/* Quick Link to Specialized Services */}
            <div className="bg-white rounded-3xl border border-slate-200 p-6 shadow-sm space-y-4">
              <h4 className="font-bold text-slate-900 text-base">
                Har du brug for specialudstyr?
              </h4>
              <ul className="space-y-2 text-xs sm:text-sm text-[#55565C]">
                <li className="flex items-center gap-2">
                  <span className="w-1 h-1 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <a href="/liftarbejde" className="hover:text-slate-900 font-medium">Liftarbejde (8m saxelift & 10,5m bomlift)</a>
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1 h-1 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <a href="/kabeltraek" className="hover:text-slate-900 font-medium">Lange kabeltræk og kabelplan</a>
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1 h-1 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <a href="/designerlamper" className="hover:text-slate-900 font-medium">Montering af danske designerlamper</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Dynamic CMS Gallery for El-arbejde */}
        <GallerySection
          gallerySlug="el-arbejde"
          title="Galleri: El-arbejde i praksis"
          subtitle="Se eksempler på eltavler, installationer og serviceudstyr."
        />

        {/* Price Banner */}
        <PriceBanner showCablePrice={false} />

        {/* Contact Form Section */}
        <div className="my-12">
          <ContactForm />
        </div>
      </div>
    </div>
  )
}
